import { DisclosurePanel } from '@headlessui/react';
import { mergeTwClasses } from '@utils/merge-tw-classes/merge-tw-classes';

import { AccordionBodyProps } from './accordion.type';

export const AccordionBody = ({ children, className, ...props }: AccordionBodyProps) => (
  <DisclosurePanel
    className={mergeTwClasses('w-full text-sm px-4 pb-3 text-neutral-50 dark:text-neutral-0', className)}
    {...props}>
    {children}
  </DisclosurePanel>
);
